var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 25H84.15L77.95 18.25C76.1 16.2 73.4 15 70.6 15H49.4C46.6 15 43.9 16.2 42 18.25L35.85 25H20C14.5 25 10 29.5 10 35V95C10 100.5 14.5 105 20 105H100C105.5 105 110 100.5 110 95V35C110 29.5 105.5 25 100 25ZM60 40C68.15 40 75.3 43.95 79.9 50H60C51.7 50 45 56.7 45 65C45 66.75 45.35 68.45 45.9 70H35.5C35.2 68.4 35 66.7 35 65C35 51.2 46.2 40 60 40ZM60 90C51.85 90 44.7 86.05 40.1 80H60C68.3 80 75 73.3 75 65C75 63.25 74.65 61.55 74.1 60H84.5C84.85 61.6 85 63.3 85 65C85 78.8 73.8 90 60 90Z",
    fill: "#4A0DFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoUpload);
export default __webpack_public_path__ + "static/media/photo-upload.d2b9528883ac66ff89a118fa3a261ef4.svg";
export { ForwardRef as ReactComponent };